import { get } from '@webapp-next/lib/request/webapp/http';
import { WebappApiResponse } from '@webapp-next/lib/types/request/request';
import { ContractStatuses } from '@webapp-next/modules/people/modules/pay-rates/definitions';
export interface PayRuleContract {
  id: string;
  title: string;
  status: string;
  // Add more fields as needed based on API response
  [key: string]: unknown;
}

export interface PayRuleContractsParams {
  pageSize?: number;
  title?: string;
  pageToken?: number;
  statuses?: string;
}

export interface PayRuleContractsResponse {
  data: PayRuleContract[];
  nextPageToken?: string;
  totalCount?: number;
}

const options = {
  headers: {
    'dp-meta-option': 'none',
  },
};

/**
 * Fetches pay rule contracts from the compliance API
 * @param {PayRuleContractsParams} params - Query parameters for filtering contracts
 * @return {Promise<WebappApiResponse<PayRuleContractsResponse>>} Promise with the contracts data
 */
export default async function payRuleContractsGet(
  params: PayRuleContractsParams = {}
): Promise<WebappApiResponse<PayRuleContractsResponse>> {
  const {
    pageSize = 100,
    title = '',
    pageToken = 0,
    statuses = `${ContractStatuses.ACTIVE}`,
  } = params;

  const queryParams = new URLSearchParams({
    pageSize: String(pageSize),
    title,
    pageToken: String(pageToken),
    statuses,
  });

  try {
    const { data } = await get(
      `/api/management/v2/compliance/contract?${queryParams.toString()}`,
      options
    );

    return {
      success: true,
      message: '',
      data: data || { data: [], nextPageToken: undefined, totalCount: 0 },
    };
  } catch (e) {
    console.error(e);
    throw e;
  }
}
